//Model imports
import { ImageConstants } from '../_constants/image-constants';
//Service imports
import { ScreenService } from '../_services/shared-services/screen.service';
//Component imports
import { BaseComponent } from './rp-base-component';
export abstract class RPBaseComponentWithGrid extends BaseComponent {
  activeHeaderFilterData: any;

  constructor(screenService: ScreenService) {
    super(screenService);
    this.activeHeaderFilterData = [
      {
        text: 'Active',
        value: ImageConstants.okImage
      },
      {
        text: 'Inactive',
        value: null
      }
    ];
  }

  loadGridState(gridStorageKey) {
    if (gridStorageKey != null) {
      const state = JSON.parse(localStorage.getItem(gridStorageKey));
      if (state) {
        state.filterValue = null; //clear filter
        state.pageIndex = 0;
        state.focusedRowKey = -1;
        state.selectedRowKeys = []; //clear selection
        for (let i = 0; i < state.columns.length; i++) {
          state.columns[i].filterValue = null;
          state.columns[i].filterType = null;
          state.columns[i].sortIndex = null;
          state.columns[i].sortOrder = null;
          state.columns[i].groupIndex = null;
          state.columns[i].selectedFilterOperation = null;
        }
      }
      return state;
    }
    return null;
  }

  saveGridState(state, gridStorageKey) {
    if (gridStorageKey != null) {
      localStorage.setItem(gridStorageKey, JSON.stringify(state));
    }
  }
}
